import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'
import viewName from '../constant.js'
import carNoPicker from '@/components/carNoPicker/carNoPicker.vue'
import {
    isValidCarNum,
    isInvalidPhone
} from '@/utils/REG'

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.editOrderInfo,
    components: {
        carNoPicker
    },
    data () {
        return {
            prov_name: '粤',
            letter_name: 'A',
            userInfo: {
                name: '', // 提货人
                car_no: '', // 车牌号，  提交订单时候，需要把车牌号提交到微养车，并生成一个默认爱车档案
                phone_number: '' // 手机号,
            }
        }
    },
    computed: {
        ...mapState({
            carNoBelongTo: state => state.editOrderInfo.carNoBelongTo,
            location: state => state.editOrderInfo.location
        }),
        ...mapGetters(['carNoBelongTo', 'user'])
    },
    async created () {},
    async activated () {
        let {
            query
        } = this.$route
        let carNo = query.icar_no
        this.userInfo = {
            name: query.icar_name, // 提货人
            car_no: carNo, // 车牌号，  提交订单时候，需要把车牌号提交到微养车，并生成一个默认爱车档案
            phone_number: query.icar_phone_number // 手机号,
        }
        this.showLoading()
        this.getLocation().then(res => {
            this.getCarNo()
            this.hideLoading()
        }).catch(res => {
            this.hideLoading()
            this.$dialog
                .alert({
                    message: '获取地理位置失败'
                })
            this.getCarNo()
        })
        // const title = '新增/编辑收货地址'
        // document.title = title
    },
    async mounted () {},
    methods: {
        async getCarNo () {
            const {
                lng,
                lat
            } = this.location
            await this.getCarNoBelongTo({
                lng: lng, // 经度
                lat: lat // 纬度
            })
        },
        ...mapActions([
            'getLocation',
            'editLocationAddress',
            'getCarNoBelongTo',
        ]),
        openPick () {
            this.$refs.carNoPicker.onOpen()
            // if (this.location.lng && this.location.lat) {
            //     this.$refs.carNoPicker.onOpen()
            // } else {
            //     this.getLocation().then(res => {
            //     }).catch(res => {
            //         this.$dialog
            //             .alert({
            //                 message: '获取地理位置失败，请重新获取'
            //             })
            //     })
            // }
        },
        onConfirm (values) {
            let confirmValue = values[1]
            this.$refs.carNoPicker.onClose()
            this.editLocationAddress({
                name: '', // 提货人
                car_no: '', // 车牌号，  提交订单时候，需要把车牌号提交到微养车，并生成一个默认爱车档案
                phone_number: '', // 手机号,
                prov_name: values[0],
                letter_id: confirmValue.letter_id,
                prov_name_first: confirmValue.prov_name,
                letter_name_first: confirmValue.letter_name
            })

            // 修改全局数据
        },
        onCancel () {
            this.$refs.carNoPicker.onClose()
        },
        // 保存前的验证
        validate () {
            return new Promise((resolve, reject) => {
                let {
                    name,
                    car_no,
                    phone_number
                } = this.userInfo
                // 判断是数据的完整性，严谨性
                if (!name) {
                    reject(String('请填写收货人姓名'))
                }
                // 用户未完善手机号码
                if (!phone_number) {
                    reject(String('请填写车主手机号码'))
                } else if (!isInvalidPhone(phone_number)) {
                    reject(String('手机号码格式有误'))
                }
                if (!car_no) {
                    reject(String('请填写车牌号码'))
                } else if (!isValidCarNum(car_no)) {
                    reject(String('车牌号码格式有误'))
                }
                resolve(this.userInfo)
            })
        },
        toast (msg) {
            this.$toast(msg)
        },
        // 保存
        async save () {
            this.validate()
                .then(res => {
                    let {
                        name,
                        car_no,
                        phone_number
                    } = res
                    // 修改全局记录
                    this.editLocationAddress({
                        name: name, // 提货人
                        car_no: car_no, // 车牌号，  提交订单时候，需要把车牌号提交到微养车，并生成一个默认爱车档案
                        phone_number: phone_number
                    })
                    this.$router.go(-1)
                })
                .catch(msg => {
                    this.toast(msg)
                })
        }
    },
    destroyed () {}
}
